'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import { Box, Typography } from '@mui/material'
import { Image } from '@media-components'
import { SectionWrapper } from '@components/common'
import { SOCIAL_MEDIA, socialShare } from '@utils/shared'
import styles from './styles'

export function SocialMediaShare() {
  const slug = usePathname()
  return (
    <SectionWrapper
      csx={{
        wrapper: styles.wrapper,
      }}
    >
      <Box sx={styles.socialWrapper}>
        <Box sx={{ alignSelf: 'normal' }}>
          <Typography variant="body1.500" sx={{ whiteSpace: 'nowrap' }}>
            Share This Blog:
          </Typography>
        </Box>

        <Box sx={styles.socialOuterWrapper}>
          <Box
            component="a"
            onClick={() =>
              socialShare({
                platform: SOCIAL_MEDIA.FACEBOOK,
                slug,
              })
            }
            sx={{ cursor: 'pointer' }}
          >
            <Image
              src="/images/facebook_Light.svg"
              alt="facebook"
              width={24}
              height={24}
              sx={{ display: 'flex' }}
            />
          </Box>

          <Box
            component="a"
            onClick={() =>
              socialShare({
                platform: SOCIAL_MEDIA.LINKEDIN,
                slug,
              })
            }
            sx={{ cursor: 'pointer' }}
          >
            <Image
              src="/images/linkedin_Light.svg"
              alt="linkedin"
              width={24}
              height={24}
              sx={{ display: 'flex' }}
            />
          </Box>
          <Box
            component="a"
            onClick={() =>
              socialShare({
                platform: SOCIAL_MEDIA.INSTAGRAM,
                slug,
              })
            }
            sx={{ cursor: 'pointer' }}
          >
            <Image
              src="/images/instagram_Light.svg"
              alt="instagram"
              width={24}
              height={24}
              sx={{ display: 'flex' }}
            />
          </Box>
          <Box
            component="a"
            onClick={() =>
              socialShare({
                platform: SOCIAL_MEDIA.TWITTER,
                slug,
              })
            }
            sx={{ cursor: 'pointer' }}
          >
            <Image
              src="/images/twitter_Light.svg"
              alt="twitter"
              width={24}
              height={24}
              sx={{ display: 'flex' }}
            />
          </Box>
        </Box>
      </Box>
    </SectionWrapper>
  )
}
